import React from "react";

type ScriptViewerProps = {
  script: string;
};

export const ScriptViewer: React.FC<ScriptViewerProps> = ({ script }) => (
  <div>
    <span className="font-medium">📝 Script:</span>
    <div className="mt-1 p-3 bg-gray-50 rounded-md max-h-40 overflow-y-auto border border-gray-200 whitespace-pre-line text-sm">
      {script || "—"}
    </div>
  </div>
);
